import { Routes, Route } from 'react-router-dom';
import DisplayClientDataInfo from './components/datainfo/DisplayClientDataInfo';
import DisplayClientData from './components/datainfo/DisplayClientData';

function AppClientDataInfo() {
    return (
        <Routes>
            <Route path="displayClientDataInfo" element={<DisplayClientDataInfo />} />
			<Route path="displayClientData" element={<DisplayClientData />} />			
        </Routes>
    );
}

export default AppClientDataInfo;